<template>
    <SidePanel @close="close">
        <template slot="header">
            <h3 class="mt-0 clearfix">
                {{ $l10n.__('Service email') }}
            </h3>
        </template>

        <template slot="content" class="prelative">
            <div class="page-emailBox">
                <div class="placeholder placeholder-small well error py-6 b-0">
                    <h3 class="mb-3">
                        {{
                            $l10n.__(
                                'Il semblerait que nous rencontrions un problème avec votre compte email',
                            )
                        }}
                    </h3>
                    <span class="typographies-paragraph-medium-bold">
                        {{ $l10n.__('Votre compte email n’est plus correctement synchronisé.') }}
                    </span>
                    <p class="typographies-paragraph-medium-regular">
                        {{
                            $l10n.__(
                                'Nous vous invitons à déconnecter puis à reconnecter votre compte email depuis les paramètres des emails.',
                            )
                        }}
                    </p>
                    <span class="typographies-paragraph-medium-bold">
                        {{
                            $l10n.__(
                                'Vous devez ensuite attendre quelques minutes pour vous assurer que la synchronisation soit effective.',
                            )
                        }}
                    </span>
                    <div class="acenter mt-4">
                        <CompassLink
                            link="/?_f=emailPreferences&amp;action=emailsParams"
                            :label="localizedTexts.linkError"
                        />
                    </div>
                </div>
            </div>
        </template>
    </SidePanel>
</template>

<script>
import SidePanel from 'vcomponents/utilities/SidePanel.vue';

export default {
    components: {
        SidePanel,
    },
    props: {},
    data() {
        return {
            localizedTexts: {
                linkError: this.$l10n.__('Accéder aux paramètres des emails'),
            },
        };
    },
    methods: {
        close() {
            this.$emit('close');
        },
    },
};
</script>
